export default {"src":"/_next/static/media/icon_nav_dd_docs_square_off.8a9066a6.svg","height":64,"width":65,"blurWidth":0,"blurHeight":0};